/***************REGISTER LEO COMPONENTS************/
import { VueLeoButton } from "@greateasternlife/leo-button";
// import { VueLeoDialog } from "@greateasternlife/leo-dialog";
import { VueLeoInput } from "@greateasternlife/leo-input";
// import { VueLeoCard } from "@greateasternlife/leo-card";
// import { VueLeoForm } from "@greateasternlife/leo-form";
// import { VueLeoCheckbox } from "@greateasternlife/leo-checkbox";
// import { VueLeoRadio } from "@greateasternlife/leo-radio";
// import { VueLeoLogo } from "@greateasternlife/leo-logo";
import { VueLeoLink } from "@greateasternlife/leo-link";
// import { VueLeoIllustration } from "@greateasternlife/leo-illustration";
import { VueLeoIcon } from "@greateasternlife/leo-icon";
// import { VueLeoInputOtp } from "@greateasternlife/leo-input-otp";
// import { VueLeoContextSwitcher } from "@greateasternlife/leo-context-switcher";
// import { VueLeoSelect } from "@greateasternlife/leo-select";
// import { VueLeoDivider } from "@greateasternlife/leo-divider";
// import { VueLeoDropdownMenu } from "@greateasternlife/leo-dropdown-menu";
// import { VueLeoProgressStepper } from "@greateasternlife/leo-progress-stepper";
// import { VueLeoBanner } from "@greateasternlife/leo-banner";
// import { VueLeoGroupSelectInput } from "@greateasternlife/leo-group-select-input";
// import { VueLeoFlag } from "@greateasternlife/leo-flag";
import { VueLeoAnimateCSS } from "@greateasternlife/leo-animate-css";
// import { VueLeoLoader } from "@greateasternlife/leo-loader";
// import { VueLeoDrawer } from "@greateasternlife/leo-drawer";
/***************REGISTER GID COMPONENTS************/

// import ContactUs from "@/components/shared/modal/ContactUs";
// import RefreshPage from "@/components/base/refresh/RefreshPage";
// import Password from "@/components/base/password/Password";
// import Stepper from "@/components/shared/stepper/Stepper";
// import DetailCard from "@/components/base/detail-card/DetailCard";
// import UsernameInput from "@/components/base/username-input/UsernameInput";
// import Alert from "@/components/base/alert/Alert";
// import Dialog from "@/components/base/dialog/Dialog";
// import Overlay from "@/components/shared/overlay/Overlay";

export const components = {
  // "leo-dialog": VueLeoDialog,
  "leo-button": VueLeoButton,
  "leo-input": VueLeoInput,
  // "leo-form": VueLeoForm,
  // "leo-card": VueLeoCard,
  // "leo-checkbox": VueLeoCheckbox,
  // "leo-radio": VueLeoRadio,
  // "leo-logo": VueLeoLogo,
  "leo-link": VueLeoLink,
  // "leo-illustration": VueLeoIllustration,
  "leo-icon": VueLeoIcon,
  // "leo-input-otp": VueLeoInputOtp,
  // "leo-context-switcher": VueLeoContextSwitcher,
  // "leo-select": VueLeoSelect,
  // "leo-divider": VueLeoDivider,
  // "leo-dropdown-menu": VueLeoDropdownMenu,
  // "leo-progress-stepper": VueLeoProgressStepper,
  // "leo-banner": VueLeoBanner,
  // "leo-group-select-input": VueLeoGroupSelectInput,
  // "leo-flag": VueLeoFlag,
  "leo-animate-css": VueLeoAnimateCSS,
  // "leo-loader": VueLeoLoader,
  // "leo-drawer": VueLeoDrawer,
  // "contact-us": ContactUs,
  // "refresh-page": RefreshPage,
  // password: Password,
  // "progress-stepper": Stepper,
  // "detail-card": DetailCard,
  // "username-input": UsernameInput,
  // alert: Alert,
  // "dialog-modal": Dialog,
  // overlay: Overlay,
};
